<template>
  <v-container fluid pa-0>
    <v-layout row class="content-area-layout">
      <v-flex xs12 fill-height style="overflow-y: auto;">
        <activity-segments :segments="segments"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import dataAccessor from '@/data-access/dataAccessor';
import loadingMixin from '@/mixins/loadingMixin';
import ActivitySegments from '@/ux/components/activities/ActivitySegments.vue';

export default {
  name: 'activity-segments-view',
  components: {
    ActivitySegments,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
      default: null,
    },
  },
  mixins: [loadingMixin],
  data: () => ({
    segments: {},
  }),
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.loadingStart(`Loading segments`);
      const activity = await dataAccessor.getActivity(this.id);
      this.segments = activity.segment_efforts;
      this.loadingEnd();
    },
  },
};
</script>

<style>
</style>
